<template>
  <fieldset class="material-card-custom">
    <legend class="primary--text font-weight-bold" v-text="title" v-if="title"></legend>    
    <v-card flat :style="styles" v-bind="$attrs" v-on="$listeners">
      
      <helper-offset v-if="hasOffset" :inline="inline" :full-width="fullWidth" :offset="offset">
        <v-card
          v-if="!$slots.offset"
          :color="color"
          class="d-flex align-center"
          dark
          min-height="80"
        >
          <slot v-if="!title && !text" name="header" />
          <div v-else class="px-3">
            <h4 class="title font-weight-light mb-2 primary--text" v-text="title" />
            <p class="body-2 mb-1 primary--text" v-text="text" />
            <slot name="goto"></slot>
          </div>
        </v-card>

        <slot v-else name="offset" />
      </helper-offset>

      <!-- <v-card-title v-else-if="title || text">
        <slot v-if="!title && !text" name="header" />
        <div v-else class="px-3">
          <h4 class="title font-weight-light mb-2 primary--text" v-text="title" />
          <p class="category body-2 mb-1 primary--text" v-text="text" />
          <slot name="goto"></slot>
        </div>
      </v-card-title> -->

      <v-card-text>
        <div class="text-right">
          <slot name="goto"></slot>
        </div>
        <slot />
      </v-card-text>

      <v-divider v-if="$slots.actions" class="mx-3" />

      <v-card-actions v-if="$slots.actions">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </fieldset>
</template>

<script>
export default {
  name: "MaterialCard",

  inheritAttrs: false,

  props: {
    color: {
      type: String,
      default: "secondary"
    },
    elevation: {
      type: [Number, String],
      default: 10
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 24
    },
    title: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: undefined
    },
    hasOffset: {
      type: Boolean,
      default: false
    }
    // addGoTo: {
    //   type: [String, Function],
    //   default: undefined
    // }
  },
  computed: {
    // hasOffset () {
    //   return this.$slots.header ||
    //     this.$slots.offset ||
    //     this.title ||
    //     this.text
    // },
    styles() {
      if (!this.hasOffset) return null;

      return {
        marginBottom: `${this.offset}px`,
        marginTop: `${this.offset * 2}px`
      };
    }
  }
};
</script>

<style>
.material-card-custom {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
  background-color: #fff;
  margin-top: -10px !important;
}

.material-card-custom legend {  
    border-width: 0 !important;
    /* width: inherit !important; */
    padding: 8px;
}

.material-card-custom .v-card__text {
  padding: 0;
}

.material-card-custom .v-card--material__header {
  min-height: 65px !important;
}

.material-card-custom .v-application .mb-2 {
  margin-bottom: 0 !important;
}
</style>
